import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "the-sidebar",
  id: "side-bar"
}

import { ref } from "vue";
import TheHumberger from "../../components/TheHumberger.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TheSidebar',
  setup(__props) {

const showSideBar = ref<boolean>(true);
function toggleSidebar() {
  showSideBar.value = !showSideBar.value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", {
      class: _normalizeClass(["z-20 fixed side-menu", { humberger: !showSideBar.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSidebar()))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("em", { class: "fa fa-home text-3xl" }, null, -1),
            _createElementVNode("span", { class: "font-bold text-xs md:text-sm" }, "Home", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/portfolio",
          class: "sideBarText",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSidebar()))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("em", {
              class: "fa fa-briefcase text-2xl",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "font-bold text-xs md:text-sm" }, "Portfolio", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about-me",
          class: "sideBarText",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSidebar()))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("em", {
              class: "fa fa-info-circle text-3xl",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "font-bold text-xs md:text-sm" }, "About Me", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "sideBarText",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSidebar()))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("i", {
              class: "fa fa-phone text-2xl md:text-3xl",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "font-bold text-xs md:text-sm" }, " Contact Me", -1)
          ])),
          _: 1
        })
      ])
    ], 2),
    _createVNode(TheHumberger)
  ]))
}
}

})